export default class {
  constructor () {
    this.$menu = document.querySelectorAll('.menu')

    if (this.$menu) {
      this.bindEvents()
    }
  }

  bindEvents () {
    this.$menu.forEach(element => {
      new Header(element)
    })
  }
}

class Header {
  constructor (item) {
    this.$menu = item
    this.$burgerOpen = this.$menu.querySelector('.menu__burger-open')
    this.$burgerClose = this.$menu.querySelector('.menu__burger-close')
    this.body = document.body
    this.html = document.documentElement
    this.$mobileWrapper = this.$menu.querySelector('.menu__mobile-wrapper')

    this.isOpen = false

    this.bindEvents()
  }

  bindEvents () {
    this.$burgerOpen.addEventListener('click', this.openAnimation.bind(this))
    this.$burgerClose.addEventListener('click', this.openAnimation.bind(this))
  }

  openAnimation () {
    this.$menu.classList.toggle("active", !this.isOpen)
    this.body.classList.toggle("overflow-hidden-body", !this.isOpen)
    this.html.classList.toggle("overflow-hidden-html", !this.isOpen)
    this.isOpen = !this.isOpen
  }
}
